import React, {useState} from 'react'
import {connect} from "react-redux";

import {useDrag} from "react-dnd";
import {send_edit_cmd} from "../../../etc/cmd";

import {styles} from "./styles";

const BmPort = ({uid, port, root, size}) => {
    const _size = size || 32

    const [over, setOver] = useState(false);

    const editmode = root.editmode

    const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
        // "type" is required. It is used by the "accept" specification of drop targets.
        type: 'bm_port',
        item: {
            type: 'bm_port',
            bm_addr: uid,
            ...port,
        },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()

            if (item && dropResult) {
                //console.log(`Drop BM [${uid}] into ${dropResult.type} ${dropResult.id}!`)
                //console.log(dropResult)
                //console.log(item)

                if (item.type === "bm_port") {
                    //console.log("N_PLANITEM DROP BM [%s] -> [%s] [%s]", uid, item.fbaddr, item.fbport)

                    let target = {}
                    target.id = dropResult.id
                    target.fbaddr = item.bm_addr
                    target.fbport = item.bm_port

                    //console.log(target)
                    send_edit_cmd(target)
                }
            }
        },
        canDrag: function(props, monitor) {
            return true
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }))

    function onClick() {

    }

    const _color = '#222222'

    const style = {
        //transform: CSS.Translate.toString(transform),
        //color: _color,
        background: port.bm_state?'#956161':'#6a876a',
        height: _size,
        width: _size,

        fontWeight: _size > 32 ? 'bold' : 'normal',
    };

    const style2 = {
        marginTop: _size > 32 ? 5 : 0,
        marginLeft: _size > 32 ? 5 : 0,
        fontWeight: _size > 32 ? 'bold' : 'normal',
    }

    return (
        <div
            onMouseEnter={() => setOver(true)}
            onMouseOut={() => setOver(false)}
            ref={drag}
             onClick={onClick}
             style={{...styles.io_port,...style}}>

            <div style={style2}>{port.bm_port}</div>
            <div style={style2}>{parseInt(port.bm_lc)===0?'':port.bm_lc}</div>

        </div>
    )
}

function mapStateToProps(state, other) {
    return {root: state.root}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BmPort)